(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);

  document.querySelectorAll('.pw3-mega img').forEach(image => { image.loading = 'eager'; image.decoding = 'async'; });

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-pw3-open]');
    if (!opener) return;
    const key = opener.dataset.pw3Open;
    requestAnimationFrame(() => {
      const drawer = document.querySelector(`[data-pw3-drawer="${CSS.escape(key)}"]`);
      if (!drawer) return;
      drawer.scrollTop = 0;
      if (key === 'mega') drawer.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.fetchPriority = 'high'; });
      const cartBody = $('[data-pw3-cart-body]', drawer);
      if (cartBody) cartBody.scrollTop = 0;
    });
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('.pw3-recommendations [data-pw3-rail-prev], .pw3-recommendations [data-pw3-rail-next]');
    if (!button) return;
    const section = button.closest('.pw3-recommendations');
    const rail = $('[data-pw3-rail]', section);
    if (!rail) return;
    const direction = button.matches('[data-pw3-rail-prev]') ? -1 : 1;
    rail.scrollBy({ left: direction * Math.max(rail.clientWidth * .82, 280), behavior: 'smooth' });
  });

  document.addEventListener('toggle', event => {
    const details = event.target.closest('.pw3-pdp__accordions details');
    if (!details) return;
    const symbol = details.querySelector('summary span');
    if (symbol) symbol.textContent = details.open ? '−' : '+';
  }, true);
})();
